export const motivosConsulta = [
  'Cuenta de usuario',
  'Cupos',
  'Operaciones'
]
